import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/auth/services/auth.service';
import { UrlTreeProvider } from '@core/routing/routes/providers/url-tree.provider';
import { Route } from '@core/routing/routes/enums/route';
import { once } from '@core/utils/rxjs/once';
import { map } from 'rxjs';

export const onlyNotLoggedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const urlTreeProvider = inject(UrlTreeProvider);
  const rootUrlTree = urlTreeProvider.urlTree(Route.Root);

  return auth.isLoggedIn().pipe(
    once(),
    map(isLogged => !isLogged || rootUrlTree)
  );
};
